// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"d259c952","107":"914a8ac6","749":"b181565a","903":"fbeb4f4f"}[chunkId] + ".chunk.js";
};